import React from 'react';

export default (props?: any) => {

    return props.fullPage ? 
        <div className="page-loading"> <i className="fa fa-circle-o-notch fa-spin fa-3x"></i></div>
        : <span> <i className="fa fa-circle-o-notch fa-spin"></i></span>;
}

